import { fetchSmsOriginNumbers } from '@/services/auth';
import { mapSmsOriginCountries, type SmsOriginCountry } from '@/utils/validation';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const PAGE_SIZES = [10, 20, 30, 40, 50] as const;
// Will be use for paginating in boost pages
const PAYMENT_PLANS_PAGE_SIZES = [6, 10, 20, 30, 40] as const;

const notInIframe = window.self === window.top;

const FALLBACK_COUNTRIES: SmsOriginCountry[] = [{ code: 'ZA', dialCode: '+27', flag: '🇿🇦' }];

export const useGeneralStore = defineStore('generalStore', {
  state: () => {
    const passwordReset = ref(false); // Will be used in otp screen for redirect
    const passwordResetFallbackToWhatsApp = ref(false);
    const iFrame = ref(!notInIframe);
    const isMenuOpen = ref(false);
    const pageSize = ref(10);
    const paymentPlanPageSize = ref(6);
    const smsOriginCountries = ref<SmsOriginCountry[]>([]);

    return {
      passwordReset,
      passwordResetFallbackToWhatsApp,
      iFrame,
      isMenuOpen,
      pageSize,
      paymentPlanPageSize,
      smsOriginCountries,
    };
  },
  persist: notInIframe,
  actions: {
    reset() {
      const smsOriginCountries = this.smsOriginCountries;
      this.$reset();
      this.smsOriginCountries = smsOriginCountries;
    },
    getPageSizeOptions(): readonly number[] {
      return PAGE_SIZES;
    },
    getPaymentPlanPageSizeOptions(): readonly number[] {
      return PAYMENT_PLANS_PAGE_SIZES;
    },
    async loadSmsOriginCountries() {
      if (this.smsOriginCountries.length) return;
      try {
        const data = await fetchSmsOriginNumbers();
        const mapped = mapSmsOriginCountries(data);
        this.smsOriginCountries = mapped.length ? mapped : FALLBACK_COUNTRIES;
      } catch {
        this.smsOriginCountries = FALLBACK_COUNTRIES;
      }
    },
  },
});
